// ============================================
// TAITIY 变体全体验系统
// ============================================

class TaitiyVariantExperience {
  constructor() {
    this.data = this.loadData();
    this.current = null;
    
    // 创建动态内容容器（插入到媒体画廊之后）
    this.createContainers();
    
    if (!this.data) return;
    this.init();
  }

  loadData() {
    const script = document.getElementById('variant-full-data');
    return script ? JSON.parse(script.textContent) : null;
  }

  createContainers() {
    // 找到媒体画廊
    const mediaGallery = document.querySelector('media-gallery');
    if (!mediaGallery) return;
    
    // 创建动态内容容器
    const container = document.createElement('div');
    container.id = 'variant-dynamic-content';
    container.innerHTML = `
      <div id="variant-description" class="variant-description"></div>
      <div id="variant-specs" class="variant-specs"></div>
    `;
    
    // 插入到媒体画廊之后
    mediaGallery.parentNode.insertBefore(container, mediaGallery.nextSibling);
    
    this.dom = {
      description: document.getElementById('variant-description'),
      specs: document.getElementById('variant-specs'),
      wrapper: container
    };
  }

  init() {
    this.bindEvents();
    this.initFromURL();
    window.taitiyVariant = this;
  }

  bindEvents() {
    // 监听 Shopify 变体切换
    document.addEventListener('variant:change', (e) => {
      if (e.detail?.variant?.id) this.switchTo(e.detail.variant.id);
    });

    // 监听单选按钮
    document.querySelectorAll('input[type="radio"][name^="options"]').forEach(input => {
      input.addEventListener('change', () => this.detectAndSwitch());
    });

    // 监听 select
    document.querySelectorAll('select[name="id"]').forEach(select => {
      select.addEventListener('change', (e) => this.switchTo(e.target.value));
    });
  }

  detectAndSwitch() {
    const selected = Array.from(document.querySelectorAll('input[name^="options"]:checked')).map(i => i.value);
    const matched = Object.values(this.data).find(v => 
      v.option1 === selected[0] && v.option2 === selected[1]
    );
    if (matched) this.switchTo(matched.id);
  }

  async switchTo(variantId, updateURL = true) {
    const variant = this.data[variantId];
    if (!variant || this.current?.id === variant.id) return;
    
    this.current = variant;
    
    if (updateURL) {
      const url = new URL(window.location);
      url.searchParams.set('variant', variantId);
      window.history.pushState({ variant: variantId }, '', url);
    }
    
    await this.animateOut();
    this.updateContent(variant);
    await this.animateIn();
  }

  updateContent(v) {
    // 更新描述
    let desc = v.description;
    if (typeof desc === 'string' && desc.startsWith('"')) {
      try { desc = JSON.parse(desc); } catch(e) {}
    }
    
    this.dom.description.innerHTML = desc || `
      <h4>${v.title}</h4>
      <p>Premium shoe storage bench with solid wood construction.</p>
    `;
    
    // 更新规格
    const specs = typeof v.specs === 'string' ? JSON.parse(v.specs) : v.specs;
    if (specs && Object.keys(specs).length > 0) {
      const labels = { length: 'Length', capacity: 'Capacity', weight: 'Weight', seating: 'Seating' };
      const entries = Object.entries(specs).filter(([_, val]) => val);
      
      this.dom.specs.innerHTML = `
        <div class="spec-grid">
          ${entries.map(([key, val]) => `
            <div class="spec-item">
              <span class="spec-label">${labels[key] || key}</span>
              <span class="spec-value">${val}</span>
            </div>
          `).join('')}
        </div>
      `;
    } else {
      this.dom.specs.innerHTML = '';
    }
  }

  animateOut() {
    return new Promise(r => {
      this.dom.wrapper?.classList.add('switching');
      setTimeout(r, 200);
    });
  }

  animateIn() {
    return new Promise(r => {
      this.dom.wrapper?.classList.remove('switching');
      setTimeout(r, 300);
    });
  }

  initFromURL() {
    const vId = new URLSearchParams(window.location.search).get('variant');
    if (vId && this.data[vId]) {
      this.switchTo(vId, false);
    } else {
      const first = Object.values(this.data).find(v => v.available);
      if (first) this.switchTo(first.id, false);
    }
  }
}

// 初始化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new TaitiyVariantExperience());
} else {
  new TaitiyVariantExperience();
}